module.exports = __webpack_public_path__ + "static/media/macaldo_resume_01_20_2019.6eebc6ff.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/macaldo_resume_01_20_2019.pdf
// module id = 43
// module chunks = 0